import { createSelector } from 'reselect';
import { updateCatalogSortingSelector } from 'selectors/testTarget/offers/updateCatalogSorting/updateCatalogSortingSelector';

const showSelector = createSelector(updateCatalogSortingSelector, updateCatalogSorting => !!updateCatalogSorting.show);

export { showSelector };
